import React, { useEffect, useState, useRef } from "react";
import BrightnessBar from "../common/brightness-bar";

const BrightnessNumber1Widget = ({
  widget,
  onValueUpdate,
  isEditing = false,
}) => {
  const [brightness, setBrightness] = useState(0);
  const [minMax, setMinMax] = useState({ min: 0, max: 100 });
  const sliderRef = React.useRef(null);
  const lastValueRef = useRef(null);

  useEffect(() => {
    if (widget) {
      const initialValue = Number(widget.value);
      const validValue = isNaN(initialValue) ? 0 : initialValue;
      setMinMax({
        min: widget.min ?? 0,
        max: widget.max ?? 100,
      });
      setBrightness(validValue);
      lastValueRef.current = validValue;
    }
    return () => {};
  }, [widget]);

  const handleValueUpdate = (data) => {
    if (data === lastValueRef.current) return;
    const updatedWidget = {
      ...widget,
      value: data,
    };
    lastValueRef.current = data;
    onValueUpdate(updatedWidget);
  };

  const handleBrightnessChange = (event, newValue) => {
    event.stopPropagation();
    const adjustedValue = Math.min(Math.max(newValue, minMax.min), minMax.max);
    setBrightness(adjustedValue);
  };

  return (
    <div className="h-full w-full relative">
      <BrightnessBar
        value={brightness}
        onChange={handleBrightnessChange}
        onValueUpdate={handleValueUpdate}
        disabled={isEditing}
        min={minMax.min}
        max={minMax.max}
        sliderRef={sliderRef}
      />
    </div>
  );
};

export default BrightnessNumber1Widget;
